var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailboxUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.34 411.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-6{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#000;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:21px;}.cls-3{stroke-width:18.93px;}.cls-4,.cls-5{stroke-width:18px;}.cls-6{stroke-width:16.96px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_5",
    "data-name": "Livello 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.67,123.33H269.33A117.17,117.17,0,0,1,386.5,240.5V353.83a.17.17,0,0,1-.17.17H10.67a.17.17,0,0,1-.17-.17V223.5A100.17,100.17,0,0,1,110.67,123.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.67,123.33h0A100.17,100.17,0,0,0,10.5,223.5V353.83a.17.17,0,0,0,.17.17h191a.17.17,0,0,0,.16-.17V214.5A91.16,91.16,0,0,0,110.67,123.33Zm44.11,191.23a1.65,1.65,0,0,1-1.65,1.66H59.21a1.66,1.66,0,0,1-1.66-1.66V264.84a1.66,1.66,0,0,1,1.66-1.66h93.92a1.66,1.66,0,0,1,1.65,1.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 294.5,
    cy: 250.91,
    r: 21.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 294.5,
    y1: 21.3,
    x2: 294.5,
    y2: 229.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.5,60.9V9.1a.1.1,0,0,1,.1-.1l111.64.66a.1.1,0,0,1,.06.18L377.69,35.26a.11.11,0,0,0,0,.15l28.62,26.08a.1.1,0,0,1-.07.17L294.6,61A.1.1,0,0,1,294.5,60.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.09,354H230a2.33,2.33,0,0,1,2.33,2.33v19.22a27.78,27.78,0,0,1-27.78,27.78h0a27.78,27.78,0,0,1-27.78-27.78V356.33a2.33,2.33,0,0,1,2.33-2.33Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailboxUp);
export default __webpack_public_path__ + "static/media/mailbox-up.f72e857c06ccf23449f185db32e8f5e0.svg";
export { ForwardRef as ReactComponent };